export enum ValidationEnum {
  NAME_REQUIRED = 'Name is required',
  LASTNAME_REQUIRED = 'Last name is required',
  NPI_REQUIRED = 'NPI is required',
  REQUESTDETAILS_REQUIRED = 'Request Detail is required',
  STATE_STATEVALID = 'State is invalid',
  TAXID_REQUIRED = 'Tax ID is required',
  MAINTENANCETYPE_REQUIRED = 'Maintenance type is required',
  STATE_REQUIRED = 'State is required',
  PROVIDERID_REQUIRED = 'Provider ID is required',
  DOC_REQUIRED = 'Document is required',
  REASONFORRESIGNATION_REQUIRED = 'Resignation reason is required',
  CAQHID_PATTERN = 'CAQH ID has invalid characters ',
  NAME_PATTERN = 'Name has invalid characters',
  LASTNAME_PATTERN = 'Last name has invalid characters',
  EFFDATE_REQUIRED = 'Effective Date is required',
  NPI_IDVALIDATOR = 'NPI ID has invalid characters',
  NPI_MINLENGTH = 'NPI ID requires 10 characters',
  NPI_MAXLENGTH = 'NPI ID requires 10 characters',
  TAXID_IDVALIDATOR = 'Tax ID has invalid characters',
  TAXID_MINLENGTH = 'Tax ID requires 9 characters',
  TAXID_MAXLENGTH = 'Tax ID requires 9 characters',
  OPTDOC_SIZEINVALID = 'Limit file size to 40 MB',
  DOC_SIZEINVALID = 'Limit file size to 40 MB',
  PROVIDERID_MINLENGTH = 'Provider ID requires 9 characters',
  IDTYPE_REQUIRED = '',
  COUNTRY_REQUIRED = '',
  OPTDOC_FILEVALIDATOR = 'Upload file of correct type',
  DOC_FILEVALIDATOR = 'Upload file of correct type',
  OPTDOC_INVALIDFILECOUNT = 'Maximum number of files that can be loaded is 10.'
}
